import axios from "@/api/http"; // 导入http中创建的axios实例
import base from "@/api/base";
import doctor from "./user"; // 导入接口域名列表

const orderList = {
  queryOrderListCount(data) {
    return axios.get(
      `${base.baseURL_clinic}/order/getAllCount?startDate=${data.startDate}&endDate=${data.endDate}&orderStatus=${data.orderStatus}&type=${data.type}&orderType=${data.orderType}&userName=${data.userName}&targetName=${data.targetName}`,);
  },
  queryOrderListPage(data) {
    return axios.get(
      `${base.baseURL_clinic}/order/getAll?currentPage=${data.currentPage}&pageSize=${data.pageSize}&startDate=${data.startDate}&endDate=${data.endDate}&orderStatus=${data.orderStatus}&type=${data.type}&orderType=${data.orderType}&userName=${data.userName}&targetName=${data.targetName}`,);
  },
  settlement(data){
    return axios.post(
      `${base.baseURL_clinic}/order/settlement?orderId=${data.orderId}`);
  },
  business(data){
    return axios.post(
      `${base.baseURL_clinic}/order/settlementBusiness?orderId=${data.orderId}`);
  },
  getSettlement(){
    return axios.get(
      `${base.baseURL_clinic}/order/getSettlement`);
  },

  getSystem1(){
    return axios.get(
      `${base.baseURL_clinic}/system/get`);
  },

  saveSystem(data){
    return axios.post(
      `${base.baseURL_clinic}/system/update`,data);
  }
}
export default orderList;



// WEBPACK FOOTER //
// ./src/network/orderList.js